// Enum to define the names of the tabs
export enum TabName {
  Consumption = 'Consumption', // "Consumption" tab
  Targets = 'Targets', // "Targets" tab
  Sources = 'Sources', // "Sources" tab
}

// Enum for notification severity
export enum NotificationSeverity {
  Info = 'info',
  Success = 'success',
  Error = 'error',
}

// Enum for notification status
export enum NotificationStatus {
  ExportInitiated = 'Export Initiated',
  ExportFailed = 'Export Failed',
}

// Enum for notification info message
export enum NotificationMessage {
  ExportStarted = 'The export process has started. Please wait...',
  ExportError = 'An error occurred while creating the Excel file.',
}

// Enum for error message
export enum ErrorMessages {
  UnexpectedError = 'An unexpected error occurred',
  FailedToParseJson = 'Failed to parse JSON from Blob',
  FailedToReadBlob = 'Failed to read Blob',
}
